import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { SharedService } from 'src/app/_shared/shared.service';
import { Constants } from 'src/app/_consts/constants';

@Injectable({ providedIn: 'root' })
export class RepAdminGuard implements CanActivate {

  constructor(
    private shared: SharedService,
    private router: Router,
    private location: Location
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    // Pokud není přihlášen vůbec
    if (!this.shared.isLoggedIn()) {
      if (route.url) {
        this.shared.setAny("last_wanted_url", this.location.path());
      }
      if (!route.data.isMainPage) {
        this.shared.warning("Nejste přihlášen");
      }
      this.router.navigate(['/login']);
      return false;
    }

    // Pokud práva ještě nejsou načtena, počkáme na ně
    if (!this.shared.rightsAll) {
      return new Promise((resolve) => {
        const watcher = this.shared.rightsAllWatch.subscribe((rights) => {
          if (rights) {
            watcher.unsubscribe();
            resolve(this.checkAdminAccess(route));
          }
        });
      });
    }

    return this.checkAdminAccess(route);
  }

  /**
   * Kontrola admin práv. Pokud má route `data.superAdmin = true`,
   * vyžaduje se i r_edit (jen Admin, ne Reservation manager).
   */
  private checkAdminAccess(route: ActivatedRouteSnapshot): boolean {
    if (!this.isAdmin()) {
      this.shared.warning("Nemáte oprávnění pro přístup do admin sekce");
      this.router.navigate(['/dashboard']);
      return false;
    }
    if (route.data?.superAdmin && !this.isSuperAdmin()) {
      this.shared.warning("Tato sekce je dostupná jen pro správce");
      this.router.navigate(['/admin']);
      return false;
    }
    return true;
  }

  /**
   * Plný admin — r_edit (správa uživatelů a lokací).
   */
  isSuperAdmin(): boolean {
    const rights = this.shared.rightsAll;
    if (!rights) return false;
    const baseRights = rights[Constants.MOD_BASE];
    return baseRights && !!baseRights.r_edit;
  }

  /**
   * Vstup do admin sekce — Admin nebo Reservation manager (oba mají r_close).
   * Rozlišení v admin sekci (jen Admin smí editovat uživatele/lokace) je přes r_edit.
   */
  isAdmin(): boolean {
    const rights = this.shared.rightsAll;
    if (!rights) return false;

    const baseRights = rights[Constants.MOD_BASE];
    return baseRights && !!baseRights.r_close;
  }
}
